import ConfirmModificationFormComponent from "../../../components/post-signature/ConfirmModificationFormComponent";



export default function REConfirmModificationBloc() {

      return (
        <div className="">
          <div className="">
            <ConfirmModificationFormComponent />
          </div>
        </div>
      )
}